import { reactMount } from '@/lib/reactMount'
import { useRef } from 'react'
import { Button } from '@/components/Button'
import { getImageByBreakpoint } from '@/lib/media'
import { ArrowRight } from '@/components/Icons'
import { getHeadingClasses } from '@/lib/headings'

export const ctaBlock = ({ dataset, umbraco }) => {
  const umbracoRef = useRef(umbraco || JSON.parse(dataset.umbraco))
  umbraco ||= umbracoRef.current
  const theme = umbraco.Theme || 'light'
  const backgroundColor = umbraco.BlockBackground ? `#${umbraco.BlockBackground}` : '#ffffff'// Button logic matching standaloneCtaBlock pattern
  const primary = umbraco.Button
  const secondary = umbraco.SecondaryButton
  const tertiary = umbraco.TertiaryButton
  const hyperlink = umbraco.ButtonText

  const buttons = []

  // Primary
  if (primary) {
    buttons.push({
      ...primary,
      variant: 'primary',
      size: 'lg'
    })
  }

  // Secondary preferred over tertiary
  if (secondary) {
    buttons.push({
      ...secondary,
      variant: 'secondary',
      size: 'lg'
    })
  } else if (tertiary) {
    buttons.push({
      ...tertiary,
      variant: 'primary-alt',
      size: 'lg'
    })
  }
  // Hyperlink only if nothing else exists
  else if (hyperlink) {
    buttons.push({
      ...hyperlink,
      variant: 'link',
      size: 'lg'
    })
  }

  const imageByBreakpoint = umbraco.Media?.Image ? getImageByBreakpoint(umbraco.Media.Image) : {}

  // Default to <h2>; promote to <h1> only when the server marks this block as first on the page.
  const isFirstBlockRaw = dataset?.isFirstBlock
  const Heading = isFirstBlockRaw === undefined
    ? 'h2'
    : (isFirstBlockRaw === 'true' ? 'h1' : 'h2')

  const headingClasses = getHeadingClasses(umbraco.TitleHeadingSize, { fallback: 'small' })

  return (
    <div data-theme={theme} className='relative isolate text-[--theme-text]' style={{ backgroundColor }}>
      {/* Set to use green gradient by default and dark radial gradient if set to dark theme. The default green gradient should not show if a background colour is selected */}
      <div aria-hidden='true' className={`absolute inset-0 -z-10 transform-gpu overflow-hidden ${theme === 'dark' ? 'bg-default-800' : ''} ${theme === 'light' && umbraco.BlockBackground === '' ? 'bg-green-1' : ''}`}>
        {theme === 'dark' &&
          <div className='absolute border-radius-[800px] left-1/2 -bottom-[540px] md:-bottom-[480px] lg:-bottom-[440px] w-[1000px] h-[800px] bg-blue-rad -translate-x-1/2 blur-2xl' />}
        {umbraco.Media && umbraco.Media.Image && (
          <picture>
            {Object.keys(imageByBreakpoint).reverse().map((minWidth) => (
              <source key={minWidth} media={`(min-width: ${minWidth})`} srcSet={imageByBreakpoint[minWidth]} />
            ))}
            <img className='w-full h-full object-cover absolute inset-0 z-10' src={umbraco.Media.Image.Url} alt='' />
          </picture>
        )}
      </div>
      <div className='mx-auto w-full max-w-xl xl:max-w-7xl'>
        <div className='_block-section _ctaBlock-section px-4 py-20 sm:px-6 lg:px-8'>
          <div className='text-center'>
            {umbraco.Title && (
              <Heading className={`text-balance font-extrabold tracking-tight ${headingClasses} mb-5 last-mb-0`}>
                {umbraco.Title}
              </Heading>
            )}
            {umbraco.Summary && (
              <div
                className='text-pretty max-w-5xl mx-auto font-semibold text-base mb-4 last-mb-0'
                dangerouslySetInnerHTML={{ __html: umbraco.Summary }}
              />
            )}

            {buttons.length > 0 &&
              <div className={`flex flex-wrap items-center justify-center gap-y-2 gap-x-6 ${umbraco.Title || umbraco.Summary ? 'mt-5' : ''}`}>
                {buttons.map((btn, index) => (
                <Button
                  key={index}
                  href={btn.Url}
                  target={btn.Target}
                  variant={btn.variant}
                  size={btn.size}
                  componentName={btn.Url?.includes('#apply-dialog') ? 'CTA Block' : null}
                >
                  {btn.variant === 'primary-alt'
                    ? (
                      <span className='block relative pr-7'>{btn.Name} <ArrowRight className='absolute -right-0.5 top-1/2 -mt-[11px]' /></span>
                      )
                    : (
                        btn.Name
                      )}
                </Button>
              ))}
              </div>}
          </div>
        </div>
      </div>
    </div>
  )
}

export const CtaBlock = ctaBlock

reactMount('ctaBlock', ctaBlock)
